import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { Row, Col } from 'antd';
import { useHistory } from 'react-router';
import { connect } from 'react-redux';
import Selectors from '../selectors';
import Actions from '../action';
import AffiliatePresentational from './affiliate-usage-presentational';
import { setStartDate } from '@helpers';
import { datePickerValues, dateFormats, chartTypes } from '@constants';
import Selectorss from '@sharedComponent/app-action-reducer/selectors';

const option = {
	tooltips: {
		yPadding: 15,
		xPadding: 15,
		bodyFontFamily: 'Gilroy-Semibold',
	},
	legend: {
		display: true,
		position: 'bottom',
		// align: 'start',
		fullWidth: true,

		labels: {
			padding: 30,
			usePointStyle: true,
			fontFamily: 'Gilroy-Semibold',
			fontSize: 10,
			fontColor: '#253D5C',
		},
	},
	responsive: false,
	cornerRadius: 15,
	scales: {
		xAxes: [
			{
				barThickness: 16,
				beginAtZero: true,
				ticks: {
					padding: 5,
					labelOffset: 5,
					beginAtZero: true,
					fontFamily: 'Gilroy-Semibold',
					fontSize: 12,
				},
				scaleLabel: {
					display: false,
				},
				gridLines: { display: false, tickMarkLength: 2 },
			},
		],
		yAxes: [
			{
				gridLines: {
					borderDash: [8, 4],
				},
				ticks: {
					fontFamily: 'Gilroy-Semibold',
					fontSize: 12,
					beginAtZero: true,
					stacked: true,
					// steps: 10,
					// stepValue: 5,
					// max: 1000,
				},
			},
		],
	},
};

const AffiliateFunctional = ({
	affiliateUsageTotalVisitLoading,
	affiliateUsageTotalVisit,
	affiliateUsageAverageTotalVisitLoading,
	affiliateUsageAverageTotalVisit,
	getAffiliateUsageTotalVisit,
	getAffiliateUsageAverageTotalVisit,
	getAffiliateUsageChartdata,
	getAffiliateUsageTabledata,
	affiliateUsageChartdataLoading,
	affiliateUsageChartdata,
	affiliateUsageTabledataLoading,
	affiliateUsageTabledata,
	affiliateUsageDropdown = [],
	userDetails,
}) => {
	const [state, setState] = useState({
		lineActive: false,
		barActive: true,
		chartType: chartTypes.BAR,
	});

	const history = useHistory();

	useEffect(() => {
		setaffiliateUsageData({
			...affiliateUsageData,
			labels: affiliateUsageChartdata.labels,
			datasets: affiliateUsageChartdata.datasets,
			datasetsTemp: affiliateUsageChartdata.datasets,
			campaignValue: ['ALL'],
		});
	}, [affiliateUsageChartdata]);

	const [affiliateUsageData, setaffiliateUsageData] = useState({
		startDate: moment(setStartDate(datePickerValues.LAST)).format(dateFormats.MM_DD_YYYY),
		endDate: moment(new Date()).format(dateFormats.MM_DD_YYYY),
		numberOfObjectsPerPage: 5,
		pageNumber: 1,
		dateFilter: datePickerValues.LAST,
		chartDataType: 'Sales',
		labels: [],
		campaignList: affiliateUsageDropdown,
		campaignValue: ['ALL'],
		datasets: [],
		datasetsTemp: [],
		isOpenDatePicker: false,
	});
	const columns = [
		{
			title: 'Company ID',
			dataIndex: 'companyId',
			key: 'companyId',
			align: 'left',
		},
		{
			title: 'Affiliate Name',
			dataIndex: 'affiliateName',
			key: 'affiliateName',
			align: 'left',
			sorter: (a, b) => a.affiliateName.localeCompare(b.affiliateName),
			render: (value, row, index) => {
				return (
					<Row align="middle">
						<Col className="flc">
							<Col className={`${value && value[0].toUpperCase()}_text text_box flc`}>{value && value[0]}</Col>
						</Col>
						<Col>{value && value}</Col>
					</Row>
				);
			},
		},
		{
			title: 'Date of Last Visit',
			dataIndex: 'lastVisitDate',
			key: 'lastVisitDate',
			align: 'left',
			render: (value, row) => {
				const splitValue = value.split(' ');
				let finalValue = value;
				if (splitValue.length == 2) {
					finalValue = splitValue[0];
				}
				return <span>{finalValue}</span>;
			},
			sorter: (a, b) => a.totalVisit - b.totalVisit,
		},
		{
			title: 'Visits',
			dataIndex: 'totalVisit',
			key: 'totalVisit',
			align: 'left',
			sorter: (a, b) => a.totalVisit - b.totalVisit,
		},
		{
			title: 'ALSV',
			dataIndex: 'avgSession',
			key: 'avgSession',
			align: 'left',
			sorter: (a, b) => a.totalVisit - b.totalVisit,
		},
	];

	const dataRangeChanged = (value) => {
		const { chartType } = state;
		let request = {
			startDate: value[0],
			endDate: value[1],
		};
		setaffiliateUsageData({
			...affiliateUsageData,
			startDate: value[0],
			endDate: value[1],
		});
		getChartTableData(request, chartType);
	};

	const dateFilter = (value) => {
		const { chartType } = state;
		let startDate = setStartDate(value);
		let request = {
			startDate: moment(startDate).format(dateFormats.MM_DD_YYYY),
			endDate: moment(new Date()).format(dateFormats.MM_DD_YYYY),
		};
		handleAffiliateUsage(true, {
			dateFilter: value,
			startDate: moment(startDate).format(dateFormats.MM_DD_YYYY),
			endDate: moment(new Date()).format(dateFormats.MM_DD_YYYY),
		});
		getChartTableData(request, chartType);
	};

	const handleCampainList = (value = []) => {
		const noValues = value.length === 0;
		let camapaign = [];
		new Promise((resolve) => {
			let arr = [];
			if (value[value.length - 1] === 'ALL') {
				camapaign = affiliateUsageData.campaignList || ['ALL'];
				resolve(affiliateUsageChartdata.datasets);
			} else {
				camapaign = [];
				value.forEach((datas) => {
					affiliateUsageChartdata.datasets.forEach((values) => {
						if (values.label === datas) {
							arr.push(values);
							camapaign.push(datas);
						}
					});
				});
				resolve(arr);
			}
		}).then((arrays) => {
			setaffiliateUsageData({
				...affiliateUsageData,
				// datasetsTemp: noValues ? affiliateUsageChartdata.datasets : arrays,
				// campaignValue: noValues ? ['ALL'] : camapaign,
				datasetsTemp: arrays || [],
				campaignValue: camapaign || [],
			});
		});
	};

	const handleChange = (label, value) => {
		const { startDate, endDate } = affiliateUsageData;
		setState({
			...state,
			[label]: value,
		});
		if (label === 'chartType') {
			getChartTableData({ startDate, endDate }, value);
		}
	};

	const handleAffiliateUsage = (multiple = false, multipleData, label, value) => {
		const data = multiple ? { ...multipleData } : { [label]: value };
		setaffiliateUsageData({
			...affiliateUsageData,
			...data,
		});
	};

	const getChartTableData = (request, chartType) => {
		getAffiliateUsageChartdata(request, chartType);
		getAffiliateUsageTabledata(request);
	};

	useEffect(() => {
		const { startDate, endDate } = affiliateUsageData;
		const { chartType } = state;
		getAffiliateUsageTotalVisit(history);
		getAffiliateUsageAverageTotalVisit();
		getChartTableData({ startDate, endDate }, chartType);
	}, []);

	const calculateWidth = (divWidth) => {
		const { labels } = affiliateUsageChartdata;
		let length = labels ? labels.length : 0;
		switch (true) {
			case length >= 0 && length <= 3:
				return divWidth;
			case length >= 4 && length <= 50:
				return divWidth;
			case length >= 20 && length <= 30:
				return 2000;
			case length >= 30 && length <= 100:
				return 3000;
			default:
				return 5000;
		}
	};

	return (
		<AffiliatePresentational
			affiliateUsageTotalVisitLoading={affiliateUsageTotalVisitLoading}
			affiliateUsageTotalVisit={affiliateUsageTotalVisit}
			affiliateUsageAverageTotalVisitLoading={affiliateUsageAverageTotalVisitLoading}
			affiliateUsageAverageTotalVisit={affiliateUsageAverageTotalVisit}
			state={state}
			handleChange={handleChange}
			affiliateUsageData={affiliateUsageData}
			dateFilter={dateFilter}
			dataRangeChanged={dataRangeChanged}
			handleCampainList={handleCampainList}
			affiliateUsageChartdataLoading={affiliateUsageChartdataLoading}
			affiliateUsageChartdata={affiliateUsageChartdata}
			affiliateUsageTabledataLoading={affiliateUsageTabledataLoading}
			affiliateUsageTabledata={affiliateUsageTabledata}
			affiliateUsageDropdown={affiliateUsageDropdown}
			columns={columns}
			option={option}
			userDetails={userDetails}
			calculateWidth={calculateWidth}
		/>
	);
};
const mapStateToProps = (state) => {
	return {
		userDetails: Selectorss.userDetails(state),
		affiliateUsageTotalVisitLoading: Selectors.affiliateUsageTotalVisitLoading(state),
		affiliateUsageTotalVisit: Selectors.affiliateUsageTotalVisit(state),
		affiliateUsageAverageTotalVisitLoading: Selectors.affiliateUsageAverageTotalVisitLoading(state),
		affiliateUsageAverageTotalVisit: Selectors.affiliateUsageAverageTotalVisit(state),
		affiliateUsageChartdataLoading: Selectors.affiliateUsageChartdataLoading(state),
		affiliateUsageChartdata: Selectors.affiliateUsageChartdata(state),
		affiliateUsageTabledataLoading: Selectors.affiliateUsageTabledataLoading(state),
		affiliateUsageTabledata: Selectors.affiliateUsageTabledata(state),
		affiliateUsageDropdown: Selectors.affiliateUsageDropdown(state),
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		getAffiliateUsageTotalVisit: (history) => dispatch(Actions.creators.getAffiliateUsageTotalVisit(history)),
		getAffiliateUsageAverageTotalVisit: () => dispatch(Actions.creators.getAffiliateUsageAverageTotalVisit()),
		getAffiliateUsageTabledata: (request) => dispatch(Actions.creators.getAffiliateUsageTabledata(request)),
		getAffiliateUsageChartdata: (request, chartType) => dispatch(Actions.creators.getAffiliateUsageChartdata(request, chartType)),
		getAffiliateUsageTabledata: (request) => dispatch(Actions.creators.getAffiliateUsageTabledata(request)),
	};
};

const Connected = connect(mapStateToProps, mapDispatchToProps)(AffiliateFunctional);

export default Connected;
